import { Component, EventEmitter, inject, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { EntranceService } from '../../service/entrance.service';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { NgClass } from "@angular/common";
import { AiButtonComponent } from "../../../shared/component/buttons/ai-button/ai-button.component";
import {
  EntranceModalSoftwaresIconsComponent,
} from "../../../../core/component/hornavbar/entrance-modal-softwares-icons/entrance-modal-softwares-icons.component";
import { SoonDemoNotActiveTagComponent, SoftwareStatus } from "../soon-demo-not-active-tag/soon-demo-not-active-tag.component";
import { appearAnimations } from "../../../../util/animations/appear-animations";
import { skeletonAnimations } from "../../../../util/animations/skeleton-animations";
import { AllIconsComponent } from "../../../shared/component/all-icons/all-icons.component";
import { ButtonComponent } from "../../../shared/component/buttons/button.component";
import { ORCA_HELP_MAIL } from "../../../../util/common/links";

@Component({
  selector: 'app-modal-entrance-card',
  templateUrl: './modal-entrance-card.component.html',
  standalone: true,
  styleUrls: ['./modal-entrance-card.component.scss'],
  animations: [appearAnimations, skeletonAnimations],
  imports: [
    NgClass,
    AiButtonComponent,
    EntranceModalSoftwaresIconsComponent,
    SoonDemoNotActiveTagComponent,
    AllIconsComponent,
    ButtonComponent,
  ],
})

export class ModalEntranceCardComponent implements OnInit, OnDestroy {
  private _destroyStream: Subject<void> = new Subject<void>();
  private entranceService: EntranceService = inject(EntranceService);

  @Input() title: ModalEntranceCardTitle;
  @Input() status: SoftwareStatus;
  @Output() activateAiTooltipEmitter = new EventEmitter<string>();
  @Output() deactivateAiTooltipEmitter = new EventEmitter<void>();

  notAccess: boolean;
  modalEntranceProps = MODAL_ENTRANCE_PROPS;
  showIcon = false;
  showTrialOverlay = false;

  ngOnDestroy(): void {
    this.entranceService.resetIconsAmount();
    this._destroyStream.next();
  }

  ngOnInit(): void {
    this.notAccess = this.title !== 'Fund performance' && this.title !== 'Investor onboarding';
    this.entranceService.showIcons
      .pipe(takeUntil(this._destroyStream))
      .subscribe((showIcons) => {
        if (showIcons) {
          this.showIcon = true;
        }
      });
  }

  incrementIconsAmount(): void {
    this.entranceService.incrementIconsAmount();
  }

  onMouseOver(): void {
    if (this.notAccess) {
      this.showTrialOverlay = true;
    }
  }

  onMouseLeave(): void {
    this.showTrialOverlay = false;
  }

  requestDemo(): void {
    window.location.href = `mailto:${ORCA_HELP_MAIL}?subject=Request Demo`;
  }
}

type ModalEntranceCardTitle = 'Fund performance' | 'Investor portal' | 'Investor onboarding' |
'Portfolio KPIs' | 'Market analysis' | 'PDF report generator' | 'Financial statements' | 'Data room';

export const MODAL_ENTRANCE_PROPS = {
  'Fund performance': {
    description: 'Tracking your cashflow and dealflow like no CFO does',
    imgSrc: '../../../../assets/landing-images/after-login/FMS.webp',
  },
  'Investor portal': {
    description: 'Easy way to distribute financial, tax and performance reports to your partners',
    imgSrc: '../../../../assets/landing-images/after-login/ip.webp',
  },
  'Investor onboarding': {
    description: 'Asking your investors to go through a 150 page subscription booklet is in the past',
    imgSrc: '../../../../assets/landing-images/after-login/IO.webp',
  },
  'Portfolio KPIs': {
    description: 'Questionnaires for quarterly reports and customized performance dashboards',
    imgSrc: '../../../../assets/landing-images/after-login/KPI.webp',
  },
  'Market analysis': {
    description: 'Refining market data and providing you with quantitative analysis',
    imgSrc: '../../../../assets/landing-images/after-login/MA.webp',
  },
  'PDF report generator': {
    description: 'Build your own reports using all the data you have in our system',
    imgSrc: '../../../../assets/landing-images/after-login/PDF.webp',
  },
  'Financial statements': {
    description: 'Automatic financial statements, capital accounts and P&L analytics',
    imgSrc: '../../../../assets/landing-images/after-login/FS.webp',
  },
  'Data room': {
    description: 'Store and share data in a simple way',
    imgSrc: '../../../../assets/landing-images/after-login/Dataroom.webp',
  },
};

